import React from 'react';
import { Edit2 } from 'lucide-react';

interface EditableContentProps {
  isEditing: boolean;
  value: string;
  onChange: (value: string) => void;
  type?: 'input' | 'textarea';
  className?: string;
  placeholder?: string;
}

const EditableContent: React.FC<EditableContentProps> = ({
  isEditing,
  value,
  onChange,
  type = 'input',
  className = '',
  placeholder = ''
}) => {
  if (!isEditing) {
    return <span className={className}>{value}</span>;
  }

  if (type === 'textarea') {
    return (
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full p-2 border border-teal-300 rounded-lg bg-white/90 text-gray-900 focus:ring-2 focus:ring-teal-500 outline-none transition-all ${className}`}
        placeholder={placeholder}
        rows={4}
      />
    );
  }

  return (
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`w-full p-2 border border-teal-300 rounded-lg bg-white/90 text-gray-900 focus:ring-2 focus:ring-teal-500 outline-none transition-all ${className}`}
      placeholder={placeholder}
    />
  );
};

export default EditableContent;